<!-- Main panel -->
<ng-container *ngIf="botFlag">
  <app-chat [userID]="userID" [sessionID]="sessionID"> </app-chat>
</ng-container>
<ng-container *ngIf="!botFlag">
  <div class="wrapper__contentComponent--expediente container my-5">
    <div class="questions-container">
      <h2>History Questions</h2>
      <ul>
        <li *ngFor="let question of questions">
          <h3>{{ question.description }}</h3>
          <ul>
            <li *ngFor="let option of question.options">
              <input
                type="radio"
                name="{{ question.id }}"
                [value]="option.descripcion"
                (change)="onOptionSelect(question.id, option.descripcion)" />
              {{ option }}
            </li>
          </ul>
        </li>
      </ul>
      <!-- Submit Button -->
      <button (click)="onSubmit()" class="btn-govco fill-btn-govco hvr-shrink">
        Enviar
      </button>
    </div>
  </div>
</ng-container>
<app-modal-video></app-modal-video>
